export default {
    accessToken: sessionStorage.getItem('accessToken'),
    refreshToken: sessionStorage.getItem('refreshToken'),
    isAuthenticated: JSON.parse(sessionStorage.getItem('authenticated')),
}